import React, { useContext, useState } from "react"
import PropTypes from 'prop-types'
import Select from './Select'
import { SEARCH, SearchContext } from "../SearchContext"

const options = Array.from({ length: 10 }, (_, i) => {
  return {label: `${i + 1} Rooms`, value: i + 1}
})
options[0].label = "1 Room"

const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const filterOptions = (candidate, input) => {
  const escapedValue = escapeRegexCharacters(input.trim())
  const regex = new RegExp('\\b' + escapedValue, 'i')
  if (input) {
    return regex.test(candidate.value)
  }
  return true
}

const SearchRooms = ({setMaxAdults, setMaxKids}) => {

  const { state: { adults }, dispatch } = useContext(SearchContext)
  const _setRooms = (payload) => dispatch({ type: SEARCH.ROOMS.SET, payload })
  const _setAdults = (payload) => dispatch({ type: SEARCH.ADULTS.SET, payload })
  const [value, setValue] = useState(options[0])

  const _handleChange = (selected, action) => {
    let value = action.action == "clear" ? '' : selected
    setValue(value)
    _setRooms(parseInt(value.value))
    if(value.value > adults) {
      _setAdults(value.value)
    }
    setMaxAdults(value.value * 10)
    setMaxKids(value.value * 10)
  }

  return (
    <label className="rooms-field" title="Number of Rooms" htmlFor="rooms">
      <div className="fields-icon-wrapper">
        <i className="fas fa-bed main-icon" />
        <Select
          name          = "rooms"
          value         = {value}
          options       = {options}
          defaultValue  = {options[0]}
          filterOption  = {filterOptions}
          handleChange  = {_handleChange}
        />
      </div>
    </label>
  )

}

SearchRooms.propTypes = {
  setMaxAdults: PropTypes.func,
  setMaxKids:   PropTypes.func
}

export default SearchRooms
